import { createContext } from "react";
const ExamsContext = createContext();
export default ExamsContext;

